export default __webpack_public_path__ + "static/media/img.6c858c62.png";